import { CheckCircle2, Phone, Mail, Building2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { Card, CardContent } from "@/components/ui/card";
import NeedHelp from "@/components/NeedHelp";
import { MobileNav } from "@/components/layout/mobile-nav";

export default function SubmissionConfirmationPage() {
  const { user } = useAuth();
  const firm = (user as any)?.firm;

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="fixed w-full" style={{ zIndex: 99 }}>
        <MobileNav />
      </div>

      <main className="flex-1 flex items-center justify-center px-4 pt-16 pb-8">
        <div className="w-full max-w-lg">
          <div className="flex flex-col items-center text-center mb-8">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-4">
              <CheckCircle2 className="h-8 w-8 text-emerald-600" />
            </div>
            <h1 className="text-2xl font-semibold text-[#243d3d]">
              Your information has been submitted successfully
            </h1>
            <p className="text-[#5a7a7a] mt-2 text-sm">
              Thank you for completing the onboarding process.
            </p>
          </div>

          {firm && (firm.firmName || firm.primaryContactPhone || firm.primaryContactEmail) && (
            <Card className="mb-6 border border-[#d6e5e5] shadow-sm">
              <CardContent className="p-5">
                <h2 className="text-sm font-semibold text-[#243d3d] mb-3">
                  Your law firm
                </h2>
                <div className="space-y-3 text-sm text-[#4c7375]">
                  {firm.firmName && (
                    <div className="flex items-center gap-3">
                      <Building2 className="h-4 w-4 flex-shrink-0" />
                      <span>{firm.firmName}</span>
                    </div>
                  )}
                  {firm.primaryContactPhone && (
                    <div className="flex items-center gap-3">
                      <Phone className="h-4 w-4 flex-shrink-0" />
                      <a
                        href={`tel:${firm.primaryContactPhone}`}
                        className="hover:underline"
                      >
                        {firm.primaryContactPhone}
                      </a>
                    </div>
                  )}
                  {firm.primaryContactEmail && (
                    <div className="flex items-center gap-3">
                      <Mail className="h-4 w-4 flex-shrink-0" />
                      <a
                        href={`mailto:${firm.primaryContactEmail}`}
                        className="hover:underline"
                      >
                        {firm.primaryContactEmail}
                      </a>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          )}

          <Card className="border border-[#d6e5e5] shadow-sm">
            <CardContent className="p-5">
              <h2 className="text-sm font-semibold text-[#243d3d] mb-3">
                What happens next
              </h2>
              <ul className="space-y-2.5 text-sm text-[#5a7a7a]">
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 block h-1.5 w-1.5 rounded-full bg-[#4c7375] flex-shrink-0" />
                  Your submitted information will be reviewed by your law firm.
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 block h-1.5 w-1.5 rounded-full bg-[#4c7375] flex-shrink-0" />
                  You may be contacted if any additional information is required.
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-0.5 block h-1.5 w-1.5 rounded-full bg-[#4c7375] flex-shrink-0" />
                  You will receive a confirmation once the review is complete.
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </main>

      <NeedHelp />
    </div>
  );
}
